import { ReduxService } from 'dashboard-services/services';

import { statusesActions } from 'actions/modules/statuses';

export const statusesInitialState = {
  jobId: undefined,
  mode: statusesActions.MODES.MAIN,
  open: false,
  name: undefined,
  type: undefined,

  past: []
}

export const statusesState = (state = statusesInitialState, action) => {
  switch (action.type) {
    case statusesActions.CHANGE_VALUE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    case statusesActions.ADD_TO_HISTORY:
      return ReduxService.updateObject(state, { past: state.past.add(state) })
    case statusesActions.BACK: {
      const newState = state.past.slice().pop()
      return newState || ReduxService.updateObject(statusesInitialState, { open: true })
    }
    case statusesActions.CLEAR:
      return statusesInitialState;
    default:
      return state;
  }
}